import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ASSET_HOST_BASE_URL } from "../../../config";
import LangContext from "../../../contexts/LangContext";
import { translate } from "../../../helper";
import "./index.css";

const Header = (props) => {
  const { lang } = useContext(LangContext);
  const [active, setActive] = useState("home");

  const handleLinkClick = (el) => {
    setActive(el.target.parentElement.id.split("-")[1]);
    document.querySelectorAll(".sh-nav-list a").forEach((link) => {
      link.classList.remove("active");
    });
    el.target.classList.add("active");
  };

  useEffect(() => {
    let path = window.location.pathname;
    if (path.includes("/parties")) {
      setActive("parties");
    } else if (path.includes("/candidates")) {
      setActive("candidates");
    } else if (path.includes("/proportional")) {
      setActive("proportional");
    } else if (path.includes("/heavy-weights")) {
      setActive("heavy-weights");
    } else if (path.includes("/battle-grounds")) {
      setActive("battle-grounds");
    } else if (path.includes("/close-margin")) {
      setActive("close-margin");
    }
    //  else if (path.includes("type=federal")) {
    //   setActive("federal");
    // } else if (path.includes("type=provincial")) {
    //   setActive("provincial");
    // }
    else if (path.includes("/result")) {
      setActive("home");
    } else {
      setActive("home");
    }
  }, []);

  const urlParams = new URLSearchParams(window.location.search);
  let type = urlParams.get("type");
  type = props.tab ? props.tab : type;

  return (
    <header className="sh-header-section">
      <div className="sh-header-container container">
        {/* Logo Section */}
        <div className="sh-brand">
          <a href={"/?type=" + props.tab + "&lang=" + lang} className="sh-logo-link">
            <img src={ASSET_HOST_BASE_URL + "/images/logo_home.png"} alt="Deshsanchar" className="sh-logo-image" />
          </a>
        </div>

        {/* Navigation Menu */}
        <nav className="sh-nav">
          <ul className="sh-nav-list">
            <li className={active === "home" ? "active" : ""} id="li-home">
              <Link 
                to={"/result/?type=" + props.tab + "&lang=" + lang} 
                onClick={handleLinkClick}
                className={(window.location.pathname.includes("/result") && !window.location.pathname.includes("type=") && false) || active === "home" ? "active" : ""}
              >
                {translate("homepage", lang)}
              </Link>
            </li>
            <li id="li-candidates">
              <Link 
                to={"/candidates?type=" + type + "&lang=" + lang} 
                onClick={handleLinkClick}
                className={active === "candidates" ? "active" : ""}
              >
                {translate("candidate", lang)}
              </Link>
            </li>
            <li id="li-heavy-weights">
              <Link 
                to={"/heavy-weights?type=" + type + "&lang=" + lang} 
                onClick={handleLinkClick}
                className={active === "heavy-weights" ? "active" : ""}
              >
                {translate("heavy_weights", lang)}
              </Link>
            </li>
           
           
            <li id="li-parties">
              <Link 
                to={"/parties?lang=" + lang} 
                onClick={handleLinkClick}
                className={active === "parties" ? "active" : ""}
              >
                {translate("parties", lang)}
              </Link>
            </li>
          </ul>
        </nav>

        {/* Right Section: Banner + Language */}
        <div className="sh-right-section">
          {/* Election Banner */}
          <div className="sh-header-banner">
            <img 
              src="https://electionassets.deshsanchar.com/election2079/images/election_banner_np.jpg" 
              alt="Election Banner" 
              className="sh-banner-image"
            />
          </div>

          {/* Language Switch */}
          {/* <div className="sh-lang-toggle">
            <button 
              value="np" 
              className={lang === "np" ? "active" : ""} 
              onClick={props.handleLanguageChange}
            >
              नेपाली
            </button>
            <button 
              value="en" 
              className={lang === "en" ? "active" : ""} 
              onClick={props.handleLanguageChange}
            >
              English
            </button>
          </div> */}
          </div>
      </div>
    </header>
  );
};

export default Header;
